/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import { getContentFromContentStack } from "../../core/contentStack";
import queryString from "query-string";
import i18n from "../../i18n";
import { setUserLanguage } from "../../services/suggesticServices";
import Button from "../shared-ui/button";
import HeaderOptionsPopup from "../shared-ui/popup/header-options";

// Infterface for PickSurveyComponent State
interface PickSurveyComponentState {
  isPopupOpen: boolean;
  iAgree: boolean;
  loading: boolean;
  result: any;
  error: object;
  isLangPopupOpen: boolean;
  contentTypeId: string;
  isTooltipOpen: boolean;
  closeTerms: boolean;
}

/**
 * Pick Survey component.
 *
 * @namespace PickSurveyComponent
 */
class PickSurveyComponent extends React.Component<
  any,
  PickSurveyComponentState
> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      isPopupOpen: false,
      isLangPopupOpen: false,
      contentTypeId: "ms_pick_a_survey_page",
      iAgree: true,
      loading: true,
      result: [],
      error: {},
      isTooltipOpen: false,
      closeTerms: false,
    };
  }

  componentDidMount() {

    // const { search } = this.props.location;
    // const { locale } = queryString.parse(search);
    // if(!sessionStorage.getItem("languageTypeOfApp")){
    //   const localLanguageType =
    //   (locale === "es-us" && "es-us") || (locale === "en-us" && "en-us");
    //   sessionStorage.setItem("languageTypeOfApp", localLanguageType || "en-us"); 
    // }
    // const localLanguageType =
    //   (locale === "es-us" && "es-us") || (locale === "en-us" && "en-us");

    // sessionStorage.setItem("languageTypeOfApp", localLanguageType || "en-us");

    //getContentFormComponenet function is called here
    this.getContentForComponent(this.state.contentTypeId);
  }

  componentDidUpdate = () => {
    if (this.props.show) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, true);
      document.addEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        true
      );
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
      document.removeEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        false
      );
    }
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  /**
   * This method is used for handle language popup
   *
   */
  handleLangPopup = () => {
    this.setState({
      isLangPopupOpen: !this.state.isLangPopupOpen,
    });
  };

  /**
   * This method is used to update the languge type
   *
   *
   */

  updateContentLanguageOnClick = () => {
    //languageType is fetched from session storage here
    const language = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    const languageType =
      language === null ? "es-us" : language === "en-us" ? "es-us" : "en-us";
    i18n.changeLanguage(languageType);

    //languageType is set on session storage here
    sessionStorage.setItem("languageTypeOfApp", languageType || "es-us");

    //suggestic call for updating user language
    if (localStorage.getItem("uniqueId")) {
      setUserLanguage();
    }
    this.getContentForComponent(this.state.contentTypeId);
    this.setState({
      isLangPopupOpen: false,
    });
  };

  updateContentLanguageOnKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.updateContentLanguageOnClick();
    }
  };

  /**
   * This method is used to handle content from content stack
   * @param {string} contentTypeId
   *
   */

  getContentForComponent = (contentTypeId: string) => {
    getContentFromContentStack(contentTypeId)
      .then((response) => {
        if (response && response.error_message) {
          this.setState({
            error: response,
          });
        } else {
          this.setState({
            result: response && response[0],
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * This method is used to handle pick survey popup close button
   *
   */
  handleClose = (e?: any) => {
    this.setState(
      {
        closeTerms: true,
      },
      () => {
        this.props.handleClose();
      }
    );
  };

  render() {
    const { isPopupOpen, result, isTooltipOpen } = this.state;
    const { title, pick_a_survey_title, full_survey, short_survey } =
      (result && result[0]) || {};
    const languageType = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    let animationClass = "pick-survey-wrapper hide";
    if (this.state.closeTerms) {
      animationClass =
        "pick-survey-wrapper animated slideInRight close-pick-survey ";
    }
    if (this.props.show) {
      animationClass = "pick-survey-wrapper animated slideInLeft";
    }
    return (
      <>
        <div className={this.props.show ? "overlay" : "overlay hide"}></div>
        <div
          className={animationClass}
          ref={(node) => {
            this.node = node;
          }}
        >
          <div className="pick-survey-header-container">
            {/* title is fetched here */}
            <div className="header-title">{title || ""}</div>
            <div className="header-icons">
              <div className="icon-wrapper">
                <span
                  role="button"
                  tabIndex={0}
                  aria-label="language translator"
                  className={
                    this.state.isLangPopupOpen
                      ? "icon lang-icon active"
                      : "icon lang-icon"
                  }
                  onClick={this.handleLangPopup}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      this.handleLangPopup();
                    }
                  }}
                ></span>
                <HeaderOptionsPopup
                  list={[
                    languageType === "en-us"
                      ? this.props.t("common.spanish_label")
                      : this.props.t("common.english_label"),
                  ]}
                  open={this.state.isLangPopupOpen}
                  handleOptionClick={this.updateContentLanguageOnClick}
                  handleOptionKeyPress={(e: any) =>
                    this.updateContentLanguageOnKeyPress(e)
                  }
                />
              </div>
              {/* <span className="icon lang-icon"></span> */}
              <span
                tabIndex={0}
                role="button"
                aria-label="close tab"
                className="icon cross-icon"
                onClick={this.handleClose}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.handleClose(e);
                  }
                }}
              ></span>
            </div>
          </div>
          <div tabIndex={-1} className={"middle-area"}>
            <div className="main-bg-wrapper">
              <div className="main-title">{pick_a_survey_title || ""}</div>
            </div>
            <div className="pick-survey-details-area">
              <div className="details-wrapper">
                <div className="heading">{full_survey?.title}</div>
                {/* <div className="sub-title">Coming in November!</div> */}
                <div className="description">
                  <ul>
                    {full_survey &&
                      full_survey?.description.map((value: any) => (
                        <li>{value || ""}</li>
                      ))}
                  </ul>
                </div>
                <div className="redirection-btn">
                  <Button
                    name={full_survey?.button_label}
                    className="app-btn"
                    onButtonClick={() => {
                      this.props.handleSelectSurvey("fullSurvey")
                    }}
                  />
                </div>
              </div>

              <div className="details-wrapper">
                <div className="heading">{short_survey?.title}</div>
                <div className="sub-title">{short_survey?.subtitle}</div>
                <div className="description">
                  <ul>
                    {short_survey &&
                      short_survey?.description.map((value: any) => (
                        <li>{value || ""}</li>
                      ))}
                  </ul>
                </div>
                <div className="redirection-btn">
                  <Button
                    name={short_survey?.button_label}
                    className="app-btn"
                    // onButtonClick={() => {
                    //   window.open(
                    //     languageType && languageType === "es-us"
                    //       ? "https://www.figma.com/proto/bkR3sQinEQfjoAiF09pVGu/Focussed-Path-Prototypes?page-id=0%3A1&node-id=3%3A2735&viewport=368%2C48%2C0.02&scaling=min-zoom&starting-point-node-id=3%3A2735&show-proto-sidebar=1" //Use For Spanish
                    //       : "https://www.figma.com/proto/bkR3sQinEQfjoAiF09pVGu/Focussed-Path-Prototypes?page-id=0%3A1&node-id=3%3A2714&viewport=368%2C48%2C0.02&scaling=min-zoom&starting-point-node-id=3%3A2714&show-proto-sidebar=1", //Use For English
                    //     "_blank"
                    //   );
                    // }}
                    onButtonClick={() => {
                      this.props.handleSelectSurvey("shortSurvey")
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PickSurveyComponent;
